// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"73":"discovery-mode","644":"account","860":"radio","897":"proton-radio"}[chunkId] + "." + {"73":"24930b4c","644":"8d72f860","860":"58ce1890","897":"5e024449"}[chunkId] + ".chunk.css";
};